<template>
  <path
    d="M20 4.00024H4C2.9 4.00024 2.01 4.90024 2.01 6.00024L2 18.0002C2 19.1002 2.9 20.0002 4 20.0002H20C21.1 20.0002 22 19.1002 22 18.0002V6.00024C22 4.90024 21.1 4.00024 20 4.00024ZM19 18.0002H5C4.45 18.0002 4 17.5502 4 17.0002V8.00024L10.94 12.3402C11.59 12.7502 12.41 12.7502 13.06 12.3402L20 8.00024V17.0002C20 17.5502 19.55 18.0002 19 18.0002ZM12 11.0002L4 6.00024H20L12 11.0002Z"
  />
</template>
